import moment from 'moment-timezone';
import i18n from 'i18next';

class DateHelpers {
  getDayName = (day) => moment().day(day).locale(i18n.language).format('dddd');

  getDayShortName = (day) => moment().day(day).locale(i18n.language).format('dd');
}

export default new DateHelpers();
